// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface V1Neo4jClusterInternalState
 */
export interface V1Neo4jClusterInternalState {
  /**
   * CoreStorageClassName names the StorageClass to use for core PVCs.
   * @type {string}
   * @memberof V1Neo4jClusterInternalState
   */
  coreStorageClassName?: string;
  /**
   *
   * @type {string}
   * @memberof V1Neo4jClusterInternalState
   */
  databaseConfigMap?: string;
  /**
   *
   * @type {string}
   * @memberof V1Neo4jClusterInternalState
   */
  databaseSecondaryConfigMap?: string;
  /**
   *
   * @type {number}
   * @memberof V1Neo4jClusterInternalState
   */
  lastReallocationServerCount?: number;
  /**
   *
   * @type {boolean}
   * @memberof V1Neo4jClusterInternalState
   */
  needsUpdate?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof V1Neo4jClusterInternalState
   */
  replacingBackend?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof V1Neo4jClusterInternalState
   */
  transferringBackend?: boolean;
}

/**
 * Check if a given object implements the V1Neo4jClusterInternalState interface.
 */
export function instanceOfV1Neo4jClusterInternalState(
  value: object,
): value is V1Neo4jClusterInternalState {
  return true;
}

export function V1Neo4jClusterInternalStateFromJSON(
  json: any,
): V1Neo4jClusterInternalState {
  return V1Neo4jClusterInternalStateFromJSONTyped(json, false);
}

export function V1Neo4jClusterInternalStateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1Neo4jClusterInternalState {
  if (json == null) {
    return json;
  }
  return {
    coreStorageClassName:
      json['coreStorageClassName'] == null
        ? undefined
        : json['coreStorageClassName'],
    databaseConfigMap:
      json['databaseConfigMap'] == null ? undefined : json['databaseConfigMap'],
    databaseSecondaryConfigMap:
      json['databaseSecondaryConfigMap'] == null
        ? undefined
        : json['databaseSecondaryConfigMap'],
    lastReallocationServerCount:
      json['lastReallocationServerCount'] == null
        ? undefined
        : json['lastReallocationServerCount'],
    needsUpdate: json['needsUpdate'] == null ? undefined : json['needsUpdate'],
    replacingBackend:
      json['replacingBackend'] == null ? undefined : json['replacingBackend'],
    transferringBackend:
      json['transferringBackend'] == null
        ? undefined
        : json['transferringBackend'],
  };
}

export function V1Neo4jClusterInternalStateToJSON(
  json: any,
): V1Neo4jClusterInternalState {
  return V1Neo4jClusterInternalStateToJSONTyped(json, false);
}

export function V1Neo4jClusterInternalStateToJSONTyped(
  value?: V1Neo4jClusterInternalState | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    coreStorageClassName: value['coreStorageClassName'],
    databaseConfigMap: value['databaseConfigMap'],
    databaseSecondaryConfigMap: value['databaseSecondaryConfigMap'],
    lastReallocationServerCount: value['lastReallocationServerCount'],
    needsUpdate: value['needsUpdate'],
    replacingBackend: value['replacingBackend'],
    transferringBackend: value['transferringBackend'],
  };
}
